// @mui
import { GlobalStyles as MUIGlobalStyles } from '@mui/material';

// ----------------------------------------------------------------------

export default function GlobalStyles() {
  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={{
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          scrollbarWidth: 'thin',
          scrollbarColor: '#80B779 #e8efe7',
        },
        '*::-webkit-scrollbar': {
          width: '10px',
          height: '10px',
        },
        '*::-webkit-scrollbar-track': {
          background: '#e8efe7',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: '#80B779',
          borderRadius: '8px',
          border: '2px solid #e8efe7',
        },
        '*::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#50724c',
        },
        '#root': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        button: {
          fontFamily: 'Raleway, Nunito',
          fontWeight: 'bold',
          textTransform: 'none',
          color: '#C0DCBD',
          borderRadius: '5px',
          padding: '10px 20px',
          fontSize: '16px',
          transition: 'background-color 0.3s ease, transform 0.3s ease',
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
        ul: {
          margin: 0,
          padding: 0,
        },
      }}
    />
  );

  return inputGlobalStyles;
}
